import React from 'react';
import { FaTrophy, FaHeartbeat, FaSmile } from 'react-icons/fa';
import coachingImage from '../assets/belowVideo/Frame 184.svg';

const CoachingPurpose = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
            <img 
              src={coachingImage} 
              alt="Tennis coaching session"
              className="w-full h-[300px] object-cover rounded-xl"
            />
          </div>
          <div className="py-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8">Coaching with Purpose</h2>
            <p className="text-lg sm:text-xl md:text-2xl font-medium text-gray-600 leading-relaxed max-w-2xl">
              Tennis is more than strokes and serves – it's about building confidence, resilience and joy on court. 
              Every session is designed to match your goals, whether you're a beginner or aiming for competition.
            </p>
            {/* <div className="mt-8">
              <div className="flex items-start mb-8">
                <div className="text-2xl mr-4 flex-shrink-0">
                  <FaTrophy />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-900">Progressive Learning</h3>
                  <p className="text-gray-600 leading-relaxed">Step-by-step approach to master every aspect of the game</p>
                </div>
              </div>
              <div className="flex items-start mb-8">
                <div className="text-2xl mr-4 flex-shrink-0">
                  <FaHeartbeat />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-900">Fitness Focus</h3>
                  <p className="text-gray-600 leading-relaxed">Improve your physical condition while enjoying the game</p>
                </div>
              </div>
              <div className="flex items-start mb-6">
                <div className="text-2xl mr-4 flex-shrink-0">
                  <FaSmile />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-900">Fun Environment</h3>
                  <p className="text-gray-600 leading-relaxed">Positive atmosphere that makes learning enjoyable</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoachingPurpose;
